import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const automationDeleteAtom = createMutationAtomFactory(
  'automations.delete',
  (params: { id: string }) => ({
    automationsAutomationDelete: {
      __args: {
        id: params.id,
      },
      deleted: true,
    },
  }),
);
